import { useLocation } from "react-router-dom";

import locales, { localeKeyForPath, nonUSPaths } from "~/locales";

export default function useLocaleSegment() {
  const { pathname } = useLocation();
  const seg = pathname.split("/")[1];
  if (!nonUSPaths.includes(seg)) return "";
  return `/${locales[localeKeyForPath(seg)].path}`;
}
